import { render, staticRenderFns } from "./EditPermissionGroupsModal.vue?vue&type=template&id=4a9de1ae&scoped=true&"
import script from "./EditPermissionGroupsModal.vue?vue&type=script&lang=js&"
export * from "./EditPermissionGroupsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPermissionGroupsModal.vue?vue&type=style&index=0&id=4a9de1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9de1ae",
  null
  
)

export default component.exports